import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports.js';

// Configure Amplify with auto-generated config
Amplify.configure(awsconfig); 